import React, { FC } from 'react';

import * as S from './loadingBar.styles';

export type LoadingBarProps = {
  percentage: number;
};

export const LoadingBar: FC<LoadingBarProps> = ({ percentage }) => {
  return (
    <S.Empty>
      <S.Filled $percentage={percentage} />
    </S.Empty>
  );
};
